"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Counter = _interopRequireDefault(require("./Counter.scss"));

var _Button = _interopRequireDefault(require("../../Button"));

var ACTION_TYPES = {
  INCREMENT: 'increment',
  DECREMENT: 'decrement'
};
var initialState = {
  count: 0
};

function reducer(state, action) {
  console.log('REDUCER: ', state, action);
  var newState;

  switch (action.type) {
    case 'increment':
      if (action.limit !== undefined && state.count >= action.limit) {
        newState = {
          count: state.count
        };
      } else {
        newState = {
          count: state.count + (action.amount ? action.amount : 1)
        };
      }

      break;

    case 'decrement':
      if (state.count === 0) {
        newState = {
          count: state.count
        };
      } else {
        newState = {
          count: state.count - (action.amount ? action.amount : 1)
        };
      }

      break;

    default:
      throw new Error();
  }

  if (action.callback) {
    action.callback(newState.count);
  }

  return newState;
}

function Counter(props) {
  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    width: '20%',
    className: _Counter["default"].button,
    onClick: function onClick() {
      return dispatch({
        type: ACTION_TYPES.DECREMENT,
        amount: props.amount,
        limit: props.limit,
        callback: props.callback
      });
    }
  }, "-"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _Counter["default"].points
  }, "".concat(state.count, " ").concat(props.limit ? "/ ".concat(props.limit) : '', " ").concat(state.count === 1 ? 'Punkt' : 'Punkte')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    width: '20%',
    className: _Counter["default"].button,
    onClick: function onClick() {
      return dispatch({
        type: ACTION_TYPES.INCREMENT,
        amount: props.amount,
        limit: props.limit,
        callback: props.callback
      });
    }
  }, "+"));
}

var _default = Counter;
exports["default"] = _default;